import styled from 'styled-components';
import { Link as LinkR } from "react-router-dom";


export const Nav = styled.nav`
    background: #93ca99;
    height: 80px;
    margin-top: -80px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.5rem;
    position: sticky;
    top: 0;
    z-index: 10;

    @media screen and (max-width: 960px){
        transition: 0.8s all ease;
    }
`;

export const NavbarContainer = styled.div`
    display: flex;
    justify-content: space-between;
    height: 80px;
    z-index: 100%
    padding: 0 24px;
    max-width: 1100px;
`;

export const NavLogo = styled(LinkR)`
color: #fff;
justify-self: flex-start;
cursor: pointer;
font-size: 1.5rem;
display: flex;
align-items: center;
margin-left: 24px;
text-decoration: none;
`;

export const MobileIcon = styled.div`
    display: none;

    @media screen and (max-width: 768px) {
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(-100%, 60%);
        font-size: 1.8rem;
        cursor: pointer;
        color: #1a3d42;

        
    &:hover{
        color: #fff;
        transition: 0.2s ease-in-out;
    } 
    }
`;

export const NavMenu = styled.ul`
    display: flex;
    align-items: center;
    list-stlye: none;
    text-align: center;
    margin-right: -22px;

    @media screen and (max-width: 768px){
        display: none;
    }
`;

export const NavItem = styled.li`
    height: 80px;
    list-style: none;
`;

export const NavLinks = styled(LinkR)`
    color: #1a3d42;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 1rem;
    height: 100%;
    cursor: pointer;

    &:hover{
        border-bottom: 5px solid  #1a3d42;
        color:  #fff;
        font-weight: 100;
        
       
        
    }

  
`;

